const url = {
  production: 'https://niftyhunt.co/v1',
  dev: 'https://niftyhunt.co/v1',
  test: 'https://niftyhunt.co/v1'
};

export default url.production;



// WEBPACK FOOTER //
// ./src/utils/url.js